import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import type { HelpCenterSharedDataRawData } from '@/Shared/AutoGenerated/Main'

export default class HelpCenterSharedData {
    constructor(
        public readonly appName: string,
        public readonly openCookieSettingsElementId: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    static hydrate(rawData: HelpCenterSharedDataRawData): HelpCenterSharedData {
        return new HelpCenterSharedData(
            rawData.appName,
            rawData.openCookieSettingsElementId,
        )
    }

    getHelpCenterLayoutProps() {
        return {
            appName: this.appName,
            openCookieSettingsElementId: this.openCookieSettingsElementId,
        }
    }
}
